import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStaffValidationSlice } from 'external-services/staff-service/types';

const NS = 'staffValidationSlice';

const initialState: IStaffValidationSlice = {
  staffEditEnabled: false,
  staffEditRequired: false,
  staffEnabled: false,
  staffRequired: false,
  staffEdit: {},
  staffNew: {},
};

const staffValidationSlice = createSlice({
  name: 'staffValidation',
  initialState,
  reducers: {
    setStaffInitialSettings: (
      state: IStaffValidationSlice,
      action: PayloadAction<IStaffValidationSlice>
    ) => {
      return action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = staffValidationSlice;
// Extract and export each action creator by name
export { actions as staffValidationActions };
// Export the reducer, either as a default or named export
export default reducer;
